import { supabase } from "../lib/supabase";

// Another person's display name and avatar (06-P2-17). user_profiles rows
// are readable only by their owner, admins and related staff, so pages that
// show someone else's name (an instructor, a reviewer, an announcement
// author) read the name-only public_profile_cards view instead.
export const PROFILE_CARD_COLUMNS = "id, full_name, avatar_url";
const CHUNK = 100;

// Map of id -> { id, full_name, avatar_url }. Never throws: a missing card
// leaves the name blank rather than breaking the page.
export async function fetchProfileCards(ids, client = supabase) {
  const unique = [...new Set((ids || []).filter(Boolean))];
  if (unique.length === 0) return new Map();
  const chunks = [];
  for (let i = 0; i < unique.length; i += CHUNK) {
    chunks.push(unique.slice(i, i + CHUNK));
  }
  try {
    const results = await Promise.all(
      chunks.map((chunk) =>
        client
          .from("public_profile_cards")
          .select(PROFILE_CARD_COLUMNS)
          .in("id", chunk),
      ),
    );
    const cards = new Map();
    for (const { data, error } of results) {
      if (error) throw error;
      for (const card of data || []) cards.set(card.id, card);
    }
    return cards;
  } catch (error) {
    console.warn("Profile cards unavailable:", error?.message || error);
    return new Map();
  }
}

// Sets row[as] to the card for row[idKey] (null when there is none) on each
// row, and returns the rows.
export async function attachProfileCards(
  rows,
  { idKey, as },
  client = supabase,
) {
  const list = (rows || []).filter(Boolean);
  const cards = await fetchProfileCards(
    list.map((row) => row[idKey]),
    client,
  );
  for (const row of list) row[as] = cards.get(row[idKey]) || null;
  return rows;
}
